const DOMAIN_LIKE = /^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i;

const NON_HOST_SCHEMES = /^(mailto|tel|data|javascript):/i;
// Schemes never contain dots — avoids treating "example.com:8080" as a scheme.
const HAS_SCHEME = /^[a-zA-Z][a-zA-Z\d+-]*:/;

/**
 * Normalize a company domain/URL into a bare hostname for logo.dev.
 * Examples:
 * - "https://www.lemon.io/about" -> "lemon.io"
 * - "example.com:8080" -> "example.com"
 * - "//lemon.io" -> "lemon.io"
 * - "mailto:x@y.com" -> ""
 */
export const normalizeCompanyDomain = (value) => {
  if (!value || typeof value !== "string") {
    return "";
  }

  const trimmed = value.trim();
  if (!trimmed || NON_HOST_SCHEMES.test(trimmed)) {
    return "";
  }

  let candidate = trimmed;

  if (candidate.startsWith("//")) {
    candidate = `https:${candidate}`;
  } else if (!HAS_SCHEME.test(candidate)) {
    // Schemeless host[:port][/path] — force http(s) so URL() can parse ports.
    candidate = `https://${candidate}`;
  }

  try {
    const host = new URL(candidate).hostname;
    if (!host) {
      return "";
    }

    return host.replace(/^www\./i, "").toLowerCase();
  } catch {
    return "";
  }
};

/**
 * Resolve the best available company domain from a career/resume chapter.
 * Schema only stores `companyDomain`, but older records may only have a
 * domain-like company name (e.g. "Lemon.io").
 */
export const getCompanyDomain = (item = {}) => {
  const explicit = normalizeCompanyDomain(
    item.companyDomain || item.companyWebsite || item.website || ""
  );

  if (explicit) {
    return explicit;
  }

  const companyName = (item.companyName || item.client || "").trim();
  if (DOMAIN_LIKE.test(companyName)) {
    return normalizeCompanyDomain(companyName);
  }

  return "";
};
